import fjGallery from "flickr-justified-gallery";

class Accordion {
    constructor() {
        this.accordions = document.querySelectorAll('.accordion, .content-accordion');
        this.init();
    }

    init() {
        this.accordions.forEach(accordion => {
            const header = accordion.querySelector('.accordion-header');
            const lessBtn = accordion.querySelector('.less');

            header.addEventListener('click', () => {
                accordion.classList.toggle('active');
            });

            lessBtn.addEventListener('click', () => {
                accordion.classList.remove('active');
                accordion.scrollIntoView({ behavior: 'smooth' });
            });
        })
    }
}

export default Accordion;